import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VuePageTitle from "vue-page-title";
import NProgress from "vue-nprogress";
import FirebaseAuthService from "./services/firebase";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueProgress from "vue-progress";
import VCalendar from "v-calendar";
import Vuelidate from "vuelidate";
import VuePlyr from "vue-plyr";
import VueLazyload from "vue-lazyload";
import "mutationobserver-shim";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
//import { defineCustomElements } from "@dytesdk/ui-kit/loader";

// NOTE: this defines components so that we can use them in our code.
//defineCustomElements();

//*Panned Removals * /
//import vueVimeoPlayer from "vue-vimeo-player";
//import VueFeather from "vue-feather";
//import VueAwesomeSwiper from "vue-awesome-swiper"; //@TDOD - remove from Package.json
// import style
//import "swiper/swiper.scss";

// import 'vue-plyr/dist/vue-plyr.css'
//Does this neeed to be top level?
import Relations from "./mixins/lists/Relations";
import Roles from "./mixins/lists/Roles";
import CallTypes from "./mixins/lists/CallTypes";
import CallStatuses from "./mixins/lists/CallStatuses";
import Places from "./mixins/lists/Places";
import Languages from "./mixins/abouts/Languages";
import Timezones from "./mixins/abouts/Timezones";
import Spiritual from "./mixins/abouts/Spiritual";
import Political from "./mixins/abouts/Political";
import GuideAccountType from "./mixins/GuideAccountType";
import BindingOptions from "./mixins/BindingOptions";
import Medications from "./mixins/lists/Medications"; //@TODo move to a different process methodology

import Moment from "./mixins/moment/Moment";
import moment from "moment";
//import VueTour from "vue-tour";
import movable from "v-movable";
//require("vue-tour/dist/vue-tour.css");

Vue.use(VueLazyload);
Vue.use(movable);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueProgress);
Vue.use(VCalendar);
window._paq.push(["trackPageView"]); //To track pageview
//Vue.use(VueTour);
//Vue.use(VueFeather);
//Vue.use(vueVimeoPlayer);

import TutorialModal from "@/components/common/tutorialModal";
Vue.component("TourModalUser", () =>
  import("./components/common/tourModalUser")
);
// Vue.component("TutorialModal", () => import("@/components/common/tutorialModal"));
//Clean this up
Vue.component("TutorialModal", TutorialModal);

Vue.mixin(Relations);
Vue.mixin(Roles);
Vue.mixin(Roles);
Vue.mixin(Places);
Vue.mixin(Languages);
Vue.mixin(Timezones);
Vue.mixin(Spiritual);
Vue.mixin(Medications);
Vue.mixin(Political);
Vue.mixin(GuideAccountType);
Vue.mixin(Moment);
Vue.mixin(BindingOptions);
Vue.mixin(CallTypes);
Vue.mixin(CallStatuses);
Vue.prototype.$moment = moment;

Vue.use(NProgress);
Vue.use(Vuelidate);
Vue.use(FirebaseAuthService);
Vue.use(VuePageTitle, {
  prefix: " D3rriana | ",
  router
});
Vue.use(VuePlyr, {
  plyr: {
    controls: []
  }
});

Vue.config.productionTip = false;
const nprogress = new NProgress({ parent: "body" });

//Vue.config.ignoredElements = ["journal-web-component"];

new Vue({
  store,
  nprogress,
  router,
  render: h => h(App)
}).$mount("#app");
